<template>
    <v-dialog v-model="dialog" persistent max-width="1500px">

        <v-card :loading="loading">
            <v-card-text>
                <v-form ref="form"
                        v-model="valid"
                        class="mt-4 ml-4 mr-4"
                        lazy-validation>
                    <v-tabs>
                        <v-tab>Anagrafica</v-tab>
                        <v-tab-item>
                            <v-row class="mt-4">
                                <v-col cols="2">
                                    <v-text-field v-model="agente.codice"
                                                  label="Codice"
                                                  outlined
                                                  dense>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field v-model="agente.nome"
                                                  label="Nome"
                                                  :rules="[v=> ((!!v && v.length>0)) || 'inserire il nome']"
                                                  outlined
                                                  dense>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field v-model="agente.cognome"
                                                  label="Cognome"
                                                  :rules="[v=> (!!v && v.length>0 ) || 'inserire il cognome']"
                                                  outlined
                                                  dense>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field v-model="agente.codiceFiscale"
                                                  label="Codice Fiscale"
                                                  outlined
                                                  dense
                                                  required
                                                  @keyup="uppercaseCFLR"
                                                  :rules="[v=> (v==null || v.length==0 || /^\d{11}$/.test(v)) || /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/.test(v) || 'inserire 11 cifre o 16 caratteri']">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="2">
                                    <v-switch class="mt-0"
                                              v-model="isPersona"
                                              label="Persona fisica"
                                              @change="changePersona">
                                    </v-switch>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="3">
                                    <v-text-field v-model="agente.mail"
                                                  label="Mail"
                                                  outlined
                                                  dense
                                                  :rules="[v=>(v==null || v.length==0 ||  /.+@.+\..+/.test(v) ) || 'inserire una mail valida']">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field v-model="agente.telefono"
                                                  label="Telefono"
                                                  outlined
                                                  dense>
                                    </v-text-field>
                                </v-col>

                                <v-col cols="3">
                                    <v-text-field v-model="agente.iban"
                                                  label="IBAN"
                                                  outlined
                                                  dense
                                                  required
                                                  :rules="[v=> (v==null || v.length==0 || /^(IT)[0-9]{2}[A-Z]{1}[0-9A-Z]{10}[0-9A-Z]{12}$/.test(v)) || 'inserire un IBAN valido']">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field v-model="agente.pec"
                                                  label="PEC"
                                                  outlined
                                                  required
                                                  dense>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field v-model="agente.sdi"
                                                  label="SDI"
                                                  outlined
                                                  @keyup="uppercaseSDI"
                                                  dense>
                                    </v-text-field>

                                </v-col>

                            </v-row>

                            <v-row v-if="!isPersona">
                                <v-col cols="3">
                                    <v-text-field v-model="agente.denominazione"
                                                  label="Denominazione"
                                                  outlined
                                                  dense
                                                  required
                                                  :rules="[v=> v!=null || v.length>0 || 'inserire la denominazione']">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-text-field v-model="agente.partitaIVA"
                                                  label="Partita IVA"
                                                  outlined
                                                  dense
                                                  required
                                                  :rules="[v=> (v==null || v.length==0 || /^\d{11}$/.test(v)) || 'inserire 11 cifre']">
                                    </v-text-field>
                                </v-col>

                            </v-row>

                            <v-row>
                            </v-row>
                            <v-row>

                                <v-col cols="2">
                                    <v-text-field v-model="agente.percVendita"
                                                  label="% vendita"
                                                  outlined
                                                  persistent-hint
                                                  :rules="[v=> v>0 && /^[0-9]*$/.test(v) || 'valore numerico >0']"
                                                  dense>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field v-model="agente.percRinnovo5"
                                                  label="% rinnovo fino a 5K"
                                                  outlined
                                                  persistent-hint
                                                  :rules="[v=> v>0 && /^[0-9]*$/.test(v) || 'valore numerico >0']"
                                                  dense>
                                    </v-text-field>
                                </v-col>

                                <v-col cols="2">
                                    <v-text-field v-model="agente.percRinnovo10"
                                                  label="% rinnovo fino a 10K"
                                                  outlined
                                                  persistent-hint
                                                  :rules="[v=> v>0 && /^[0-9]*$/.test(v) || 'valore numerico >0']"
                                                  dense>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field v-model="agente.percRinnovo15"
                                                  label="% rinnovo fino a 15K"
                                                  outlined
                                                  persistent-hint
                                                  :rules="[v=> v>0 && /^[0-9]*$/.test(v) || 'valore numerico >0']"
                                                  dense>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field v-model="agente.percRinnovo20"
                                                  label="% rinnovo fino a 20K"
                                                  outlined
                                                  persistent-hint
                                                  :rules="[v=> v>0 && /^[0-9]*$/.test(v) || 'valore numerico >0']"
                                                  dense>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field v-model="agente.percRinnovoOltre"
                                                  label="% rinnovo oltre i 20K"
                                                  outlined
                                                  persistent-hint
                                                  :rules="[v=> v>0 && /^[0-9]*$/.test(v) || 'valore numerico >0']"
                                                  dense>
                                    </v-text-field>
                                </v-col>
                                <!--<v-col cols="3">
                                    <v-text-field v-model="agente.percRinnovoOltre"
                                                  label="% rinnovo oltre i 20K"
                                                  outlined
                                                  :rules="[v=> v==null || v.length==0 || /^[0-9]{1,2}$/.test(v) || 'nn']"
                                                  persistent-hint
                                                  dense>
                                    </v-text-field>
                                </v-col>-->
                            </v-row>
                        </v-tab-item>
                        <v-spacer></v-spacer>
                        <v-btn class="mt-2 mr-2" color="teal" :dark="valid"
                               @click="salva"
                               :loading="loadingSalva"
                               :disabled="!valid">
                            Salva
                        </v-btn>
                        <v-btn class="mt-2 mr-2" color="orange darken-2" dark
                               :loading="loadingAnnulla"
                               @click="annulla">
                            Annulla modifiche
                        </v-btn>
                        <v-btn class="mt-2 mr-2"
                               color="blue darken-2" dark
                               @click.stop="dialog = false">
                            Chiudi
                        </v-btn>
                    </v-tabs>
                </v-form>
            </v-card-text>
        </v-card>
        <v-snackbar v-model="snackSuccess"
                    timeout="2000"
                    color="success">
            <v-icon dark>
                mdi-checkbox-marked-circle
            </v-icon>
            Operazione eseguita con successo.
        </v-snackbar>
        <v-snackbar v-model="snackError"
                    timeout="2000"
                    color="error">
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Errore durante l'esecuzione dell'operazione.
        </v-snackbar>
        <v-snackbar v-model="snackCancel"
                    timeout="2000"
                    color="warning">
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Modifiche annullate.
        </v-snackbar>
        <v-snackbar v-model="snackRemote"
                    timeout="2000"
                    color="info">
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Aggiornamento remoto.
        </v-snackbar>
        <v-snackbar v-model="snackErrorOp"
                    timeout="2000"
                    color="error"
                    centered>
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Errore: superato limite operatori
        </v-snackbar>
        <v-snackbar v-model="snackErrorProf"
                    timeout="2000"
                    color="error"
                    centered>
            <v-icon dark>
                mdi-alert-circle
            </v-icon>
            Errore: superato limite professionisti
        </v-snackbar>
    </v-dialog>
</template>

<script>

    import { callService, callPost, Snack } from '@/modules/utilities.js'
    import { bus } from '@/main.js'


    export default {
        data: () => ({
            dialog: false,
            valid: true,
            nuovo: false,
            snackSuccess: false,
            snackError: false,
            snackCancel: false,
            snackRemote: false,
            snackErrorOp: false,
            snackErrorProf: false,
            dialogDelete: false,
            loading: false,
            loadingSalva: false,
            loadingAnnulla: false,
            isPersona: false,
            id: '',
            agente: {
                id: '',
                codice: '',
                denominazione: '',
                codiceFiscale: '',
                cognome: 'pippo',
                nome: '',
                partitaIVA: '',
                pec: '',
                sdi: '',
                telefono: '',
                mail: '',
                iban: '',
                isPersona: true
            },
        //    headers: [
        //        { text: 'Descrizione', value: 'descrizione', width: '20%' },
        //        { text: 'Intestazione', value: 'intestazione', width: '20%' },
        //        { text: 'IBAN', value: 'iban', width: '25%' },
        //        { text: 'Causale', value: 'bic', width: '25%' },
        //        { text: 'Default', value: 'isDefault' },
        //        { text: '', value: 'operazione', sortable: false }, 
        //    ],
        //    listaConti: [],
        }),
        mounted() {
            if (!this.$store.state.logged) {
                this.$router.replace({ name: "login" });
            }            
        },
        computed: {

        },
        methods: {
            //logout() {
            //    this.$store.dispatch('logout');
            //    this.$store.dispatch('setUtente', null);
            //    this.$router.replace({ name: "login" });
            //},
            uppercaseCFLR() {
                this.agente.codiceFiscale = this.agente.codiceFiscale.toUpperCase();
            },
            uppercaseSDI() {
                this.agente.sdi = this.agente.sdi.toUpperCase();
            },
            checkData(d) {
                var tok = d.split("/");
                var dIso = new Date([tok[2],tok[1],tok[0]].join("-"));
                return !isNaN(dIso);
            },
            localData(stringDate) {
                if (!stringDate) return null;
                var d = new Date(stringDate);
                let month = (d.getMonth() + 1).toString();
                let day = d.getDate().toString();
                let year = d.getFullYear();
                if (month.length < 2) {
                    month = '0' + month;
                }
                if (day.length < 2) {
                    day = '0' + day;
                }
                return [day, month, year].join('/');                
            },
            changePersona(persona) {
                //if (persona) {
                //    this.idPeriodicitaContabile = 0;
                //    this.tariffeContabilitaCliente = [];
                //}
                //else {
                //    //vorrei chiamare la funzione con la periodicit� di default
                //    this.idPeriodicitaContabile = 1;
                //    this.changePerdiodicitaContabile();
                //}
            },
            serverData(stringDate) {
                //da gg/mm/aaaa a aaaa-mm-gg//

                if (!stringDate) return null;
                var tok = stringDate.split("/");                
                return [tok[2], tok[1], tok[0]].join('/');                
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            resetValidation() {
                this.$refs.form.resetValidation()
            },
            async annulla() {
                this.loadingAnnulla = true;
                await this.internalCreated(Snack.cancel);    
                this.loadingAnnulla = false;
            },            
            async onAgenteChanged({ lista, sessionID }) {
                if (sessionID == "-1" || sessionID == this.$store.state.sessionID) return;

                if (lista.find(cod => cod == this.agente.id)) {
                    await this.internalCreated(Snack.remote);
                }
            }, 
            async salva() {
                if (!this.$refs.form.validate()) return;
                alert("salva");
                //preparazione dati
                this.agente.isPersona = this.isPersona;
                alert("salva2");
                let paramJson={
                    partition: this.$store.state.partition,
                    username: this.$store.state.utente.username,
                    token: this.$store.state.utente.token,
                    sessionID: this.$store.state.sessionID,
                    agente: this.agente
                };

                this.loadingSalva = true;
                let ute = await callPost('api/agente/save', paramJson);

                if (ute) {
                    this.agente.id = ute.id;
                    this.nuovo = false;
                    bus.$emit('agente-changed-bus', { lista: [this.agente.id], sessionID: "-1" });
                    bus.$emit('agente-snack-succes',{});
                    this.loadingSalva = false;  
                    this.dialog = false;
                }
                else {
                    await this.internalCreated(Snack.error);
                    this.loadingSalva = false;   
                }

            },
            async internalCreated(snack) {
                let param=[];
           
                param=[this.agente.id];
                let agente = await callService("api/agente", param);

                if (this.nuovo) {
                    this.$nextTick(() => {
                        this.$refs.form.resetValidation();
                    });
                }

                this.agente = agente;

                this.isPersona = this.agente.isPersona;

                this.snackSuccess = (snack == Snack.success);
                this.snackError = (snack == Snack.error);
                this.snackCancel = (snack == Snack.cancel);
                this.snackRemote = (snack == Snack.remote);

            },
           
        },
        async created() {           

            this.$updaterHub.$on('agente-changed', this.onAgenteChanged)
            var vm = this;

            bus.$on('dialog-show-agente', async function (agente) {
                vm.dialog = true;
                vm.loading = true;
                vm.nuovo = agente.id == "0";
                vm.agente.id = agente.id;
                await vm.internalCreated(Snack.nothing);
                vm.loading = false;
            });   
        },
        beforeDestroy() {
            this.$updaterHub.$off('agente-changed', this.onAgenteChanged);
            this.$updaterHub.$off('dialog-show-agente');
        }
    }

</script>

